module.exports = __webpack_public_path__ + "img/9788992920827.89da8c7a.jpg";